import React from 'react'

const Manual_cloudbeds_revision_cargo = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">Cloudbeds - Revisión de Cargo a la Cuenta</h2>
        <p className="text-lg text-gray-700 mb-6">
          Pasos claros para acceder y revisar los cargos a la habitación de clientes desde Cloudbeds.
        </p>
        <iframe
          src="https://scribehow.com/embed/Cloudbeds__Revision_de_Cargo_a_la_Cuenta__zawdVfmPSaeOppPAyUbV8Q?as=scrollable"
          className="scribe-iframe-general-202"
          width="100%"
          height="2000"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_cloudbeds_revision_cargo
